import { defineMessages } from 'react-intl';

export const messages: {
	closeButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	closeModal: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	copyLinkButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	explanation: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	heading: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	linkCopied: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	requestLinkInputLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	shareLinkPrompt: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	teamworkCollectionAlt: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	visualAlt: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	teamworkCollectionAlt: {
		id: 'twc.xflow.modal.requested.trial.screen.teamwork.collection.alt',
		defaultMessage: 'Teamwork Collection',
		description:
			'Accessibility alt text for the Teamwork Collection logo image shown on the requested trial screen.',
	},
	heading: {
		id: 'twc.xflow.modal.requested.trial.screen.heading',
		defaultMessage: 'Your request is pending',
		description: 'Heading text for the requested trial screen',
	},
	explanation: {
		id: 'twc.xflow.modal.requested.trial.screen.explanation',
		defaultMessage:
			'The admin for your workspace needs to approve the request before you can try Teamwork Collection.',
		description:
			'Explanatory paragraph on the requested trial screen informing the user that an admin must approve their request before they can try Teamwork Collection.',
	},
	shareLinkPrompt: {
		id: 'twc.xflow.modal.requested.trial.screen.share.link.prompt',
		defaultMessage: 'For faster approval, share the link below with your admin',
		description:
			'Instructional text on the requested trial screen encouraging the user to share a link with their admin to speed up approval.',
	},
	copyLinkButton: {
		id: 'twc.xflow.modal.requested.trial.screen.copy.link.button',
		defaultMessage: 'Copy link',
		description:
			'Button on the requested trial screen that copies the admin approval link to the clipboard.',
	},
	closeButton: {
		id: 'twc.xflow.modal.requested.trial.screen.close.button',
		defaultMessage: 'Close',
		description:
			'Button on the requested trial screen that closes the modal and returns the user to the previous view.',
	},
	linkCopied: {
		id: 'twc.xflow.modal.requested.trial.screen.link.copied',
		defaultMessage: 'Link copied!',
		description:
			'Confirmation message displayed on the requested trial screen after the user successfully copies the admin link.',
	},
	visualAlt: {
		id: 'twc.xflow.modal.teamwork.collection.requested.trial.screen.visual.alt',
		defaultMessage: 'A graphic that displays Jira, Confluence, Confluence, and Loom integrations',
		description: 'Alternate text for a graphics about bundled apps',
	},
	closeModal: {
		id: 'twc.xflow.modal.teamwork.collection.requested.trial.screen.close',
		defaultMessage: 'Close modal',
		description:
			'Accessible label for the close button on the Teamwork Collection requested trial screen modal.',
	},
	requestLinkInputLabel: {
		id: 'twc.xflow.modal.requested.trial.screen.request.link.input.label',
		defaultMessage: 'Trial request link',
		description: 'Accessible label for the trial request link input field',
	},
});
